import { BreadcrumbListComponent } from '@aipb/gulliver/dynamic-gallery/ui';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { LightboxModule } from 'ngx-lightbox';
import { RecordComponent, RecordListComponent, RecordPaginationComponent, RecordToolbarComponent } from './components';
import { RecordMasonryModule } from './modules/record-masonry/record-masonry.module';
import { RecordOpenLayersModule } from './modules/record-open-layers/record-open-layers.module';

@NgModule({
  declarations: [RecordListComponent, RecordToolbarComponent, RecordComponent, RecordPaginationComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    LightboxModule,
    LazyLoadImageModule,
    MatMenuModule,
    BreadcrumbListComponent,
    FontAwesomeModule,
    MatTabsModule,
    RecordOpenLayersModule,
    RecordMasonryModule
  ],
  exports: [RecordComponent]
})
export class DynamicGalleryFeatureRecordModule {}
